import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { getOfferImageLink } from 'lib/image';
import { toOfferLink } from 'lib/links';
import { formatOfferPageDescription, formatOfferPageTitle } from 'lib/offer';

import APP from 'constants/app';

const OfferHead = ({
  offerSlug,
  offerTitle,
  offerPrice,
  offerPublished,
  offerPhoto,
  storeName,
  storeDomain,
}) => {
  const getOfferPageDescription = () =>
    formatOfferPageDescription({
      offerPublishedDate: offerPublished,
      storeUrl: storeDomain,
      offerTitle,
      offerPrice,
      storeName,
    });

  return (
    <NextSeo
      title={formatOfferPageTitle(offerTitle, offerPrice)}
      description={getOfferPageDescription()}
      openGraph={{
        type: 'website',
        url: `${APP.URL}${toOfferLink(offerSlug)}`,
        title: formatOfferPageTitle(offerTitle, offerPrice),
        description: getOfferPageDescription(),
        images: [
          {
            url: getOfferImageLink(offerPhoto, 268),
            alt: formatOfferPageTitle(offerTitle, offerPrice),
            height: 300,
            width: 300,
          },
        ],
      }}
    />
  );
};

OfferHead.defaultProps = {
  offerSlug: null,
  offerTitle: null,
  offerPrice: 0,
  offerPublished: null,
  offerPhoto: null,
  storeName: null,
  storeDomain: null,
};

OfferHead.propTypes = {
  offerSlug: PropTypes.string,
  offerTitle: PropTypes.string,
  offerPrice: PropTypes.number,
  offerPublished: PropTypes.string,
  offerPhoto: PropTypes.string,
  storeName: PropTypes.string,
  storeDomain: PropTypes.string,
};

export default OfferHead;
